import { FieldTypeEnum } from 'packages/sdks-next/growp'
import React, { useContext } from 'react'
import { BaseSpeacialSettingWrapper } from './BaseSpeacialSetting'
import { FileSizeSetting } from './FileSizeSetting'
import { FileNumSetting } from './FileNumSetting'
import { NumberSetting } from './NumberSetting'
import { DateSetting } from './DateSetting'
import { OptionStyleSetting } from './OptionStyleSetting'
import { OptionNumSetting } from './OptionNumSetting'
import { ProductSetting } from './ProductSetting'
import { QuestionnaireContext } from './context'
import { changeMetaData } from './utils'
import { DateTypeEnum, SelectTypeEnum } from './types'

/**
 * 复合类型表单项
 *
 * @returns React.ReactNode
 */
export const SelectSpeacialSetting: React.FC = () => {
  const { questionnaires, activeItemIndex, setQuestionnaires, structIsChange } =
    useContext(QuestionnaireContext)
  if (activeItemIndex === undefined || !questionnaires) return null
  const currentQuestion = questionnaires[activeItemIndex] || {}

  const onChangeMetaData = (param: object, notChangeStruct = false) => {
    const newQuestionnaire = changeMetaData(
      questionnaires,
      activeItemIndex || 0,
      param
    )
    setQuestionnaires([...newQuestionnaire])
    !notChangeStruct && structIsChange && structIsChange()
  }

  const onDateTypeChange = (checked: boolean, checkedType: DateTypeEnum) => {
    if (!checked) return
    onChangeMetaData({ dateType: checkedType })
  }

  const getSpeacialSetting = () => {
    const { type } = currentQuestion
    const {
      maxCount,
      minCount,
      fileSizeLimit,
      precision,
      dateType,
      selectType,
    } = currentQuestion.metadata || {}
    switch (type) {
      case FieldTypeEnum.Attachment: {
        if (currentQuestion.name === 'avatar') {
          return null
        }
        return (
          <>
            <BaseSpeacialSettingWrapper
              title="文件大小限制"
              component={
                <FileSizeSetting
                  isUserField={currentQuestion.isUserField}
                  fileSizeLimit={fileSizeLimit}
                  onChange={(v) => onChangeMetaData({ fileSizeLimit: v })}
                />
              }
            />
            <BaseSpeacialSettingWrapper
              title="上传数量限制"
              component={
                <FileNumSetting
                  isUserField={currentQuestion.isUserField}
                  minCount={minCount}
                  maxCount={maxCount}
                  onSelect={(param) => onChangeMetaData(param)}
                />
              }
            />
          </>
        )
      }
      case FieldTypeEnum.Integer: {
        return (
          <BaseSpeacialSettingWrapper
            title="小数位数"
            component={
              <NumberSetting
                isUserField={currentQuestion.isUserField}
                precision={precision}
                onSelect={(v: number) => onChangeMetaData({ precision: v })}
              />
            }
          />
        )
      }
      case FieldTypeEnum.DateRange: {
        return (
          <BaseSpeacialSettingWrapper
            title="日期类型"
            component={
              <DateSetting
                isUserField={currentQuestion.isUserField}
                dateType={dateType}
                onChange={onDateTypeChange}
              />
            }
          />
        )
      }
      case FieldTypeEnum.Date:
      case FieldTypeEnum.Time: {
        return (
          <BaseSpeacialSettingWrapper
            title="时间类型"
            component={
              <DateSetting
                isUserField={currentQuestion.isUserField}
                dateType={dateType}
                onChange={onDateTypeChange}
              />
            }
          />
        )
      }
      case FieldTypeEnum.Single: {
        return (
          <>
            {currentQuestion.isUserField ? null : (
              <BaseSpeacialSettingWrapper
                title="选项样式"
                component={
                  <OptionStyleSetting
                    selectType={selectType || SelectTypeEnum.Checked}
                    onChange={(param) => onChangeMetaData(param, true)}
                  />
                }
              />
            )}
          </>
        )
      }
      case FieldTypeEnum.Multi: {
        return (
          <>
            {currentQuestion.isUserField ? null : (
              <BaseSpeacialSettingWrapper
                title="选项样式"
                component={
                  <OptionStyleSetting
                    selectType={selectType || SelectTypeEnum.DropDown}
                    onChange={(param) => onChangeMetaData(param, true)}
                  />
                }
              />
            )}

            <BaseSpeacialSettingWrapper
              title="限制用户可选数量"
              component={
                <OptionNumSetting
                  isUserField={currentQuestion.isUserField}
                  maxCount={maxCount || 0}
                  minCount={minCount || 0}
                  optionsLen={currentQuestion.options?.length || 2}
                  onChange={(param) => onChangeMetaData(param)}
                />
              }
            />
          </>
        )
      }
      case FieldTypeEnum.Product: {
        return (
          <BaseSpeacialSettingWrapper
            title="复合内容"
            component={<ProductSetting />}
          />
        )
      }
    }
  }
  return <>{getSpeacialSetting()}</>
}
